import React from 'react';

// "Ao salvar" box from the design (§04): what saving this appointment will trigger.
export interface SaveEffect { ok: boolean; text: string }

const SaveEffectsPanel: React.FC<{ title: string; effects: SaveEffect[] }> = ({ title, effects }) => (
  <div style={{ borderRadius: 10, background: 'var(--bg,#f7f4ee)', padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 8 }}>
    <div style={{ font: "600 10px 'JetBrains Mono',monospace", letterSpacing: '.06em', textTransform: 'uppercase', color: 'var(--ink-muted,#5a6660)' }}>{title}</div>
    {effects.map(e => (
      <div key={e.text} style={{ display: 'flex', gap: 8, fontSize: 13 }}><span style={{ color: e.ok ? '#3d6e4f' : '#b08544' }}>{e.ok ? '✓' : '○'}</span>{e.text}</div>
    ))}
  </div>
);

export default SaveEffectsPanel;
